export const generateSlug = (title: string) =>
  title
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')

export const TRUST_CENTER_SECTIONS = {
  CERTIFICATIONS: 'certifications',
  CONTROLS: 'controls',
  RESOURCES: 'resources',
  SUBPROCESSORS: 'subprocessors',
} as const

export type ITrustCenterSection = (typeof TRUST_CENTER_SECTIONS)[keyof typeof TRUST_CENTER_SECTIONS]

export const trustCenterPath = (orgToken: string, section?: ITrustCenterSection) =>
  section ? `/trust-center/${orgToken}/${section}` : `/trust-center/${orgToken}`

export const PAGE_CONTAINER_CLASS = 'mx-auto flex w-full max-w-screen-2xl flex-col gap-6 px-4 pt-8 pb-14 md:px-12'
